<input
  placeholder="{{ placeholder || ('txt_address_phone_field_label' | translate) }}"
  [ngModel]="phone"
  (ngModelChange)="onPhoneChange($event)"
  [disabled]="disabled"
  name="phone"
  type="tel"
/>
